export const SLICE_NAME = 'myTeamEvalPage';
